import { get, post } from './api.service';

const base_url = 'public/v1';

export const getPublicAccount = (uuid: string) => {
    return get(`${base_url}/accounts/${uuid}`);
}

export const getPublicPlans = (accountUuid: string) => {
    return get(`${base_url}/accounts/${accountUuid}/plans`);
}

export const createPublicSubscription = (accountUuid: string, data: any) => {
    return post(`${base_url}/accounts/${accountUuid}/subscribe`, data);
}
